
function Register() {
    return (
        <div style={{ color: "red", fontSize: '40px' }} >
            Register work here !
        </div>
    );
}
export default Register;